import PropTypes from 'prop-types'
import React from 'react'
import { shallowEqual, useSelector } from 'react-redux'
import { NavLink } from 'react-router-dom'
import Typography from 'gu-ui-kit/Typography'
import styles from '../nav.module.scss'

const BenchmarksLink = ({ className, activeClassName, exact, to, children }) => {
  const { benchmark = 0 } = useSelector(
    (state) => ({
      benchmark: state.notifications?.counters?.benchmark,
    }),
    shallowEqual,
  )

  return (
    <NavLink
      activeClassName={activeClassName}
      className={className}
      exact={exact}
      to={to}
    >
      {children}
      {benchmark !== 0 && (
        <Typography
          className={styles['nav__link-badge']}
          component={'span'}
          variant={'Body-10'}
        >
          {benchmark}
        </Typography>
      )}
    </NavLink>
  )
}
export default BenchmarksLink

BenchmarksLink.propTypes = {
  className: PropTypes.string,
  activeClassName: PropTypes.string,
  exact: PropTypes.bool,
  to: PropTypes.string,
  children: PropTypes.node,
}
